<template>
  <div class="col-lg-3 col-md-4">
    <div class="footer-title">
      <h5>
        {{ _T('Help') }}
        <span class="according-menu">
          <svg width="12" height="6" fill="none">
            <use xlink:href="#downArrow" />
          </svg>
        </span>
      </h5>
    </div>
    <ul class="footer-content">
      <li v-if="all_static_pages_by_slug_search(CONST.CONTACT_US_SLUG)">
        <router-link :to="{ name: 'contact_us' }">
          {{ _T('Contact Us') }}
        </router-link>
      </li>
      <li v-if="all_static_pages_by_slug_search(CONST.FAQ_SLUG)">
        <router-link :to="{ name: 'faq' }">
          {{ _T('FAQs') }}
        </router-link>
      </li>
      <li v-if="all_static_pages_by_slug_search(CONST.HOW_IT_WORKS_SLUG)">
        <router-link :to="{ name: 'how_it_work' }">
          {{ _T('How it works') }}
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Menu2',
  computed: {
    ...mapGetters(['_T', 'all_static_pages_by_slug_search']),
  },
}
</script>
